import React from 'react';
import { useLanguage } from '../../lib/LanguageContext/LanguageContext.tsx';
import styles from './LanguageToggle.module.scss';

const LanguageToggle: React.FC = () => {
  const { currentLang, toggleLanguage } = useLanguage();

  return (
    <button 
      onClick={toggleLanguage} 
      className={styles.languageToggle} 
      aria-label={currentLang === 'en' ? 'Switch to Chinese' : 'Switch to English'}
    >
      {currentLang === 'en' ? '中文' : 'EN'}
    </button>
  );
};

export default LanguageToggle;
